import { useState, useRef, useEffect } from "react";
import JsonLd from "@/components/base/JsonLd";

const faqs = [
  {
    q: "Quais empresas a Ferrarezi atende?",
    a: "Atendemos empresas de todos os portes, desde pequenas e médias empresas com 5 colaboradores até grandes corporações com centenas de funcionários. Nossa abordagem é personalizada para cada realidade, independentemente do tamanho ou segmento de atuação.",
  },
  {
    q: "A Ferrarezi ajuda a reduzir custos com benefícios?",
    a: "Sim. A redução de custos é um dos nossos principais objetivos. Através de análise técnica, renegociação de contratos, comparação de operadoras e estratégias de gestão de sinistralidade, conseguimos resultados expressivos sem comprometer a qualidade dos benefícios.",
  },
  {
    q: "Vocês revisam contratos já existentes?",
    a: "Com certeza. Fazemos uma auditoria completa dos contratos vigentes, identificando oportunidades de melhoria, cláusulas desfavorárias, coberturas desnecessárias e possibilidades de renegociação. Muitos clientes encontram economias significativas logo na primeira revisão.",
  },
  {
    q: "A Ferrarezi oferece suporte na implantação?",
    a: "Sim, gerenciamos todo o processo de implantação: desde a contratação com as operadoras até a comunicação com os colaboradores. Cuidamos da burocracia para que o RH possa focar no que realmente importa.",
  },
  {
    q: "Como funciona o atendimento após a contratação?",
    a: "Nosso relacionamento não termina na venda. Oferecemos acompanhamento contínuo com reuniões periódicas, relatórios de indicadores, suporte operacional para demandas do dia a dia e revisões estratégicas anuais. Você terá sempre um consultor dedicado à sua empresa.",
  },
  {
    q: "Quanto tempo leva para estruturar um pacote de benefícios?",
    a: "O prazo varia conforme a complexidade da empresa, mas em geral o diagnóstico e a proposta estratégica ficam prontos em até 2 semanas. A implantação completa pode levar de 30 a 60 dias, dependendo das operadoras envolvidas.",
  },
];

const clientes = [
  { name: "Da Praça", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/1dcb5164-2afa-4d47-8cfd-c35dcbf2f848_Logos-Clientes-.pdf_14-13.png" },
  { name: "Daslu", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/b9ccb441-3f01-455e-b2d1-45708c891bf7_Logos-Clientes-.pdf_14-12.png" },
  { name: "Aliter", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/c23fd694-1674-44da-8d09-ae67f39aeccd_Logos-Clientes-.pdf_14-11.png" },
  { name: "Camelo Pizzaria", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/e1cf7b92-f837-405a-832b-6af2735a6b23_Logos-Clientes-.pdf_14-10.png" },
  { name: "OAB", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/5ef88912-13ef-4d0b-a027-9ae41cd129fa_Logos-Clientes-.pdf_14-9.png" },
  { name: "Todeschini", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/d29d4b97-003c-433c-8dc4-2b3d9243ffe3_Logos-Clientes-.pdf_14-8.png" },
  { name: "Lovel", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/0516a554-d703-4aa4-ad59-970637c60748_Logos-Clientes-.pdf_14-7.png" },
  { name: "GM Promo", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/0338e913-4359-467a-aa16-2683844e436d_Logos-Clientes-.pdf_14-6.png" },
  { name: "La Guapa", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/d13026bc-2a6a-40e5-8b08-d29caa8f55d2_Logos-Clientes-.pdf_14-5.png" },
  { name: "Negreiros", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/c165a614-59ac-4ced-8be2-c952cb1fdf4f_Logos-Clientes-.pdf_14-4.png" },
  { name: "MAX", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/13327e2c-f0cc-40e6-a128-3997b58f813a_Logos-Clientes-.pdf_14-3.png" },
  { name: "Grupo Euro17", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/ebe1b0b3-f86f-4403-ae4f-5487a0407fe2_Logos-Clientes-.pdf_14-2.png" },
  { name: "Artefacto", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/9a48d752-fd30-49c4-a625-44ceda4498d0_Logos-Clientes-.pdf_14-1.png" },
  { name: "Nahoe", img: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/e54c36ff-0ecd-4735-a34a-b6d99294fbef_Logos-Clientes-.pdf_14.png" },
];

const allClientes = [...clientes, ...clientes, ...clientes];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.a,
    },
  })),
};

function MiniLogosCarrossel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<number>(0);
  const posRef = useRef<number>(0);
  const pausedRef = useRef<boolean>(false);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const speed = 0.4;
    const animate = () => {
      if (!pausedRef.current) {
        posRef.current += speed;
        const totalWidth = track.scrollWidth / 3;
        if (posRef.current >= totalWidth) posRef.current = 0;
        track.style.transform = `translateX(-${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(animate);
    };
    animRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  return (
    <div className="mt-8 relative overflow-hidden rounded-xl">
      {/* Degrade esquerda */}
      <div
        className="absolute left-0 top-0 h-full w-10 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to right, #F8F8F6 0%, transparent 100%)" }}
      />
      {/* Degrade direita */}
      <div
        className="absolute right-0 top-0 h-full w-10 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to left, #F8F8F6 0%, transparent 100%)" }}
      />
      <div
        ref={trackRef}
        className="flex items-center gap-3 will-change-transform"
        style={{ width: "max-content" }}
        onMouseEnter={() => { pausedRef.current = true; }}
        onMouseLeave={() => { pausedRef.current = false; }}
      >
        {allClientes.map((cliente, idx) => (
          <div
            key={`mini-${cliente.name}-${idx}`}
            className="flex-shrink-0 flex items-center justify-center rounded-lg border border-[#FBC52D]/40 hover:border-[#FBC52D] transition-all duration-300 cursor-default group"
            style={{ width: 145, height: 85, background: "#FBC52D" }}
          >
            <div className="w-[100px] h-[60px] flex items-center justify-center">
              <img
                src={cliente.img}
                alt={cliente.name}
                className="w-full h-full object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="border-b border-black/10 last:border-0">
      <button
        className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
        onClick={() => setOpen(!open)}
      >
        <span className={`text-sm md:text-base font-semibold transition-colors duration-200 ${open ? "text-black" : "text-black/80 group-hover:text-black"}`}>
          {q}
        </span>
        <div className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-all duration-300 ${open ? "bg-black rotate-45" : "bg-black/10 group-hover:bg-black/20"}`}>
          <i className={`ri-add-line text-base transition-colors ${open ? "text-white" : "text-black/60"}`} />
        </div>
      </button>
      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? contentRef.current?.scrollHeight + "px" : "0px" }}
      >
        <p className="text-black/70 text-sm leading-relaxed pb-5">{a}</p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".faq-item").forEach((item, i) => {
              setTimeout(() => item.classList.add("faq-visible"), i * 60);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq" className="py-16 lg:py-20 bg-[#F8F8F6]" ref={sectionRef}>
      <JsonLd data={faqJsonLd} />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div className="lg:sticky lg:top-28">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-6 h-px bg-black" />
              <span className="text-black text-xs font-semibold tracking-widest uppercase">
                Dúvidas frequentes
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black leading-tight mb-6">
              Perguntas que nossos clientes fazem
            </h2>
            <p className="text-black/70 text-lg leading-relaxed mb-8">
              Transparência é um dos nossos valores. Aqui respondemos as principais dúvidas sobre como trabalhamos.
            </p>
            <button
              onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap bg-black text-white font-semibold px-7 py-3.5 rounded-full hover:bg-gray-900 transition-all duration-200 cursor-pointer text-sm"
            >
              Tenho outra dúvida
            </button>

            {/* Mini carrossel de logos abaixo do botão */}
            <MiniLogosCarrossel />
          </div>

          {/* Right: FAQ */}
          <div className="bg-[#FBC52D] rounded-2xl p-6 md:p-8">
            {faqs.map((faq) => (
              <div key={faq.q} className="faq-item opacity-0 translate-y-4 transition-all duration-400">
                <FAQItem q={faq.q} a={faq.a} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .faq-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}